import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import Actions from '~/Actions';
import Actions_Wind_V2 from '~/Actions_Wind_V2';
import permission from '~/skills/permission';
import { Select, MenuItem, TableRow, TableCell, TableHead, TableContainer, TableBody, Table } from '@material-ui/core';
import { ArrowBackIos, ArrowForwardIos, FirstPage, LastPage, CheckCircle } from '@mui/icons-material';
import { S_Input, S_Btn_Search, S_Btn_Add, S_Select, S_Title } from '~/components/SearchItem';
import { T_TitleCell, T_Btn_Function, T_TableRow } from '~/components/TableItem';
import T_common from '~/components/TableItem/common';
import PageTitle from '~/components/PageTitle';
import ReportEditorDialog from './ReportEditorDialog';
import ConfirmDialog from './ConfirmDialog';
import { logError } from '~/common/utils';

const Page_ReportManagement = (props) => {
    const { reportMailList = {}, getBaseData, deleteReportMail, getReportMailList, addReportMail, updateReportMail, windFields } = props
    const [searchState, setSearchState] = useState({
        keyword: '',
        per_page: 20,
        page: 1,
        sort: false,
        sort_field: 'user_name'
    });

    const [openDialog, setOpenDialog] = useState(false);
    const [mode, setMode] = useState('add');
    const [selectedUser, setSelectedUser] = useState(null);
    const [openConfirmDialog, setOpenConfirmDialog] = useState(false);

    useEffect(() => {
        getBaseData();
    }, []);

    const handleOpenDialog = (mode, user = null) => {
        setSelectedUser(user);
        setMode(mode);
        setOpenDialog(true);
    };

    const handleCloseDialog = () => {
        setOpenDialog(false);
        setSelectedUser(null);
    };

    const handleOpenConfirmDialog = (user) => {
        setSelectedUser(user);
        setMode('delete');
        setOpenConfirmDialog(true);
    };

    const handleCloseConfirmDialog = async (ok) => {
        try {
            if (ok) {
                const { id } = selectedUser;
                await deleteReportMail(id);
                refresh();
            }
        } catch (error) {
            logError(error, 'deleteReportMail');
            window.alert('刪除失敗 (Failed to delete data)');
        } finally {
            setOpenConfirmDialog(false);
            setSelectedUser(null);
        };
    };

    const handleSaveResult = async (data) => {
        try {
            if (mode === 'add') {
                await addReportMail(data);
            } else if (mode === 'edit') {
                await updateReportMail({ ...data, id: selectedUser.id });
            }
            refresh();
        } catch (error) {
            logError(error, mode === 'add' ? 'addReportMail' : 'updateReportMail');
            window.alert(mode === 'add' ? '新增失敗 (Failed to add data)' : '修改失敗 (Failed to update data)');
        } finally {
            handleCloseDialog();
        }
    };

    const refresh = () => {
        const { keyword, page, per_page, sort, sort_field } = searchState;
        getReportMailList({
            page,
            per_page,
            body: {
                keyword,
                sort: sort ? 'desc' : 'asc',
                sort_field,
            },
        });
    };

    useEffect(() => {
        refresh();
    }, [searchState.per_page, searchState.page, searchState.sort, searchState.sort_field]);

    // const search = () => setSearchState(prevState => ({ ...prevState, page: 1 }), refresh);

    const search = () => setSearchState(prevState => ({ ...prevState, page: 1 }));

    const clickSearch = () => {
        search();
    };

    const handleAdd = () => {
        handleOpenDialog('add');
    };

    const handleView = (user) => { handleOpenDialog('view', user); };
    const handleEdit = (user) => { handleOpenDialog('edit', user); };
    const handleDelete = (user) => { handleOpenConfirmDialog(user) };

    const renderSearchBar = () => {
        const { keyword } = searchState;
        return (
            <div style={{ marginTop: 24, display: 'flex' }}>
                <div style={{ marginLeft: 16 }}>
                    <S_Title text='關鍵字' />
                    <S_Input value={keyword} onChange={t => setSearchState(prevState => ({ ...prevState, keyword: t }))} onEnterKey={clickSearch} />
                </div>
                <div style={{ marginLeft: 16, display: 'flex', flexDirection: 'column-reverse' }}>
                    <S_Btn_Search onClick={clickSearch} />
                </div>
            </div>
        );
    };

    const renderAddNewBar = () => (
        <div style={{ marginTop: 24, display: 'flex', alignItems: 'center' }}>
            <div style={{ color: '#064B6F', fontSize: 20, lineHeight: '24px', letterSpacing: '0.25%' }}>發送清單</div>
            <S_Btn_Add onClick={handleAdd} style={{ marginLeft: 24 }} disabled={false} />
        </div>
    );

    const renderTableTitle = () => {
        const { sort, sort_field } = searchState;
        const onChangeSort = t => {
            // setSearchState(prevState => ({ ...prevState, sort_field: t, sort: sort_field === t ? !sort : false }), refresh);
            setSearchState(prevState => ({ ...prevState, sort_field: t, sort: sort_field === t ? !sort : false }));
        };
        const ary = [
            { name: '序號 (#)' },
            { name: '使用者 (User Name)', id: 'user_name' },
            { name: '組織名稱 (Organization)', id: 'organization' },
            { name: '電子信箱 (Email)', id: 'email' },
            // { name: '備註說明 (Note)', id: 'note' },
            { name: '日報 (Daily Report)', id: 'subscribe_status_for_daily_report' },
            { name: '週報 (Weekly Report)', id: 'subscribe_status_for_weekly_report' },
            { name: '月報 (Monthly Report)', id: 'subscribe_status_for_monthly_report' },
            { name: '上次更新時間 (Last Updated Time)', id: 'update_date' },
            { name: '' },
        ];

        return (
            <TableHead>
                <TableRow style={{ height: 48 }}>
                    {/* {ary.map((o, i) => (
                        <T_TitleCell
                            key={i}
                            text={o.name}
                            arrow={!!o.id}
                            bol={sort_field === o.id ? sort : true}
                            onClick={() => onChangeSort(o.id)}
                        />
                    ))} */}
                    {ary.map((o, i) => (
                        <TableCell key={i} align='center' style={{ fontSize: 16, fontWeight: 800 }}>{o.name}</TableCell>
                    ))}
                </TableRow>
            </TableHead>
        );
    };

    const renderTableBody = () => {
        const { list: user_list = [] } = reportMailList;
        const { per_page } = searchState;
        const cellStyle = { fontSize: 14 };
        let start = 0;
        const { pagination_info: { page_index: page = 0, total = 0 } } = reportMailList;
        if (page > 0) {
            start = (page - 1) * per_page + 1;
            if (start > total) start = 0;
        }

        const getStatusDisplay = (check) => {
            return check === '1' ? <CheckCircle style={{ color: 'green' }} /> : '';
        };

        return (
            <TableBody>
                {user_list.map((o, i) => (
                    <T_TableRow key={i} backgroundColor={i % 2 === 0 ? '#E0FDFF' : 'white'}>
                        <TableCell align='center' style={cellStyle}>{i + start}</TableCell>

                        <TableCell align='center' style={cellStyle}>{o.user_name}</TableCell>
                        <TableCell align='center' style={cellStyle}>{o.organization}</TableCell>
                        <TableCell align='center' style={cellStyle}>{o.email}</TableCell>
                        {/* <TableCell align='center' style={cellStyle}>{o.note}</TableCell> */}
                        <TableCell align='center' style={cellStyle}>{getStatusDisplay(o.subscribe_status_for_daily_report)}</TableCell>
                        <TableCell align='center' style={cellStyle}>{getStatusDisplay(o.subscribe_status_for_weekly_report)}</TableCell>
                        <TableCell align='center' style={cellStyle}>{getStatusDisplay(o.subscribe_status_for_monthly_report)}</TableCell>
                        <TableCell align='center' style={cellStyle}>{o.update_date}</TableCell>

                        <TableCell style={{ width: 214 }}>
                            <div style={{ width: '100%', display: 'flex', flexDirection: 'row' }}>
                                <T_Btn_Function text='檢視' backgroundColor={T_common.type1} onClick={() => handleView(o)} />
                                <T_Btn_Function text='編輯' backgroundColor={T_common.type2} onClick={() => handleEdit(o)} style={{ marginLeft: 8, marginRight: 8 }} />
                                <T_Btn_Function text='刪除' backgroundColor={T_common.type3} onClick={() => handleDelete(o)} />
                            </div>
                        </TableCell>
                    </T_TableRow>
                ))}
            </TableBody>
        );
    };

    const renderTableBar = () => {
        const { pagination_info: { has_next = false, has_prev = false, page_index: page = 0, pages = 1, total = 0 } } = reportMailList;
        const { per_page, page: statePage } = searchState;
        const returnPages = () => {
            const array = [];
            for (let i = 1; i <= pages; i++) {
                array.push(i);
            }
            return array;
        };
        const returnPers = () => [20, 30, 40];
        const canFirst = page > 1;
        const canLast = page < pages;

        return (
            <div style={{ height: 48, display: 'flex', alignItems: 'center', width: '98%', backgroundColor: 'white', borderBottomRightRadius: 8, borderBottomLeftRadius: 8, paddingTop: 6, paddingBottom: 6 }}>
                <div style={{ flex: 1 }} />
                <FirstPage style={{ height: 24, width: 24, color: canFirst ? 'black' : 'gray', cursor: canFirst ? 'pointer' : 'default' }} onClick={() => { if (canFirst) setSearchState(prevState => ({ ...prevState, page: 1 })); }} />
                <ArrowBackIos style={{ marginLeft: 3, marginRight: 5, height: 16, width: 16, color: has_prev ? 'black' : 'gray', cursor: has_prev ? 'pointer' : 'default' }} onClick={() => { if (has_prev) setSearchState(prevState => ({ ...prevState, page: prevState.page - 1 })); }} />
                <div style={{ fontSize: 14 }}>第</div>
                
                <Select
                    style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px', marginRight: 8, marginLeft: 8 }}
                    variant="outlined"
                    value={statePage}
                    onChange={e => setSearchState(prevState => ({ ...prevState, page: e.target.value })) }
                >
                    {returnPages().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
                </Select>
                <div style={{ fontSize: 14, marginRight: 8 }}>{`/${pages} 頁，每頁`}</div>
                <Select
                    style={{ backgroundColor: 'white', height: 36, fontSize: 16, letterSpacing: '0.15px' }}
                    variant="outlined"
                    value={per_page}
                    onChange={e => setSearchState(prevState => ({ ...prevState, per_page: e.target.value }))}
                >
                    {returnPers().map((o, i) => <MenuItem key={i} value={o}>{o}</MenuItem>)}
                </Select>
                <div style={{ fontSize: 14, marginLeft: 8 }}>{`筆，共${total}筆`}</div>
                <ArrowForwardIos style={{ marginLeft: 5, height: 16, width: 16, color: has_next ? 'black' : 'gray', cursor: has_next ? 'pointer' : 'default' }} onClick={() => { if (has_next) setSearchState(prevState => ({ ...prevState, page: prevState.page + 1 })); }} />
                <LastPage style={{ marginRight: 19, height: 24, width: 24, color: canLast ? 'black' : 'gray', cursor: canLast ? 'pointer' : 'default' }} onClick={() => { if (canLast) setSearchState(prevState => ({ ...prevState, page: pages })); }} />
                <div style={{ flex: 1 }} />
            </div>
        );
    };

    const renderTable = () => {
        const { list: user_list = [] } = reportMailList;
        const haveData = user_list.length > 0;
        return (
            <TableContainer style={{ marginTop: 18, maxWidth: '98%' }}>
                <Table style={{ backgroundColor: 'white', borderTopLeftRadius: 8, borderTopRightRadius: 8 }}>
                {renderTableTitle()}
                {haveData && renderTableBody()}
                </Table>
            </TableContainer>
        );
    };

    const renderMainPage = () => {
        const { list: user_list = [] } = reportMailList;
        const haveData = user_list.length > 0;
        return (
            <div style={{
                position: 'absolute',
                left: 13,
                right: 0,
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'start',
                overflow: 'auto',
            }}>
                <PageTitle text='報表發送維護管理' />
                {/* {renderSearchBar()} */}
                {renderAddNewBar()}
                {renderTable()}
                {haveData && renderTableBar()}
                {!haveData && <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: 30 }}>尚無資料</div>}
                {
                    openDialog && 
                    <ReportEditorDialog
                        open={openDialog}
                        onClose={handleCloseDialog}
                        onSave={handleSaveResult}
                        mode={mode}
                        data={selectedUser}
                        windFields={windFields}
                    />
                }
                {
                    openConfirmDialog &&
                    <ConfirmDialog
                        open={openConfirmDialog}
                        onClose={handleCloseConfirmDialog}
                        data={selectedUser}
                    />
                }
            </div>
        );
    };

    return renderMainPage();
};

const mapStateToProps = state => ({
    reportMailList: state.data.ReportMailList,
    windFields: state.data.WindcontractsV2,
    ...permission.returnPermission(state),
});

const mapDispatchToProps = dispatch => ({
    getReportMailList: body => Actions.getReportMailList(dispatch, body),
    deleteReportMail: id => Actions.deleteReportMail({ id }),
    addReportMail: body => Actions.addReportMail({ body }),
    updateReportMail: body => Actions.updateReportMail({ body }),
    getBaseData: () => {
        Actions_Wind_V2.Gis.getWindcontractsV2(dispatch);
    },
});

export default connect(mapStateToProps, mapDispatchToProps)(Page_ReportManagement);
